export default {
  API_ENDPOINT: "https://sheltered-stream-40763.herokuapp.com/api",
  TOKEN_KEY: "nutred-client-auth-token",
};
